const CAMPAIGN_PAGE_TABS = tt => ({
  LEADS: {
    key: "LEADS",
    title: tt("leads"),
  },
  SMART_SEQUENCE: {
    key: "SMART_SEQUENCE",
    title: tt("smart-sequence"),
  },
  SETTINGS: {
    key: "SETTINGS",
    title: tt("settings"),
  },
  STATS: {
    key: "STATS",
    title: tt("stats"),
  },
})

const campaignTabsConstants = tt => ({
  CAMPAIGN_PAGE_TABS: CAMPAIGN_PAGE_TABS(tt),
})

export default campaignTabsConstants
